export default __webpack_public_path__ + "static/it-9a2d171e69722c289d4a7f12c2481275.svg";